<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getSubPage } from '@/api/pageData'
import { imgPathFn } from '@/utils/common'

export default {
  name: 'DialogId4',
  components: { ModuleTitle },
  props: {
    currentModule: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path,
      pageData: []
    }
  },
  created() {
    this.initPageData()
  },
  methods: {
    previewList(list) {
      let arr = []
      list.forEach(item => {
        arr.push(imgPathFn(item.photo))
      })
      return arr
    },
    initPageData() {
      const params = {
        titleid: Number(this.currentModule.titleid),
        title: this.currentModule.title,
        subtitle: '',
        userid: localStorage.getItem('screenUserid') || 0,
        village: localStorage.getItem('currentCommunity') || ''
      }
      getSubPage(params).then(res => {
        if (res.code === 0) {
          this.pageData = res.msg[0].list
        }
      })
    }
  }
}
</script>

<template>
  <div class="dialog-id-4">
    <div class="title-container">
      <module-title :title="currentModule.title" :margi-bottom="40" />
    </div>
    <div class="dialog-container">
      <el-image class="line" :src="require('imgs/modules/dialog-modules/id-4-line.png')" alt="line" />
      <div class="img-group" :class="{'single-img-group': pageData.length === 1}">
        <div
          v-for="(v, i) in pageData"
          :key="`dialog-id-${i}`"
          class="item"
        >
          <el-image
            class="item-img"
            :class="{'full-img': currentModule.title === '十大英模'}"
            :src="v.photo | imgPath"
            :preview-src-list="previewList(pageData)"
            alt="acti"
            fit="cover"
          />
          <p class="item-title">{{ v.headline || '' }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
// 1330
.dialog-id-4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  .title-container {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }
  .dialog-container {
    width: 957px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .line {
      width: 957px;
      height: 25px;
    }
  }
}
.img-group {
  display: flex;
  flex-wrap: wrap;
  column-gap: 10px;
  row-gap: 30px;
  width: 913px;
  background-color: #fafafa;
  padding: 14px 22px 30px;
  box-sizing: border-box;
  height: 570px;
  overflow-y: scroll;
  &::-webkit-scrollbar { // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
  .item {
    .item-img {
      width: 427px;
      height: 310px;
      border-radius: 5px;
    }
    .full-img {
      height: 630px;
    }
    .item-title {
      width: 420px;
      font-size: 18px;
      font-weight: bold;
      color: #000;
      line-height: 29px;
      margin-top: 20px;
    }
  }
}
.single-img-group {
  display: flex;
  justify-content: center;
  .item {
    .item-img {
      width: 570px;
      height: 415px;
    }
    .item-title {
      width: 550px;
    }
  }
}
</style>
